import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

/**
 * SkeletonCard - Veri yükleme iskeleti.
 *
 * Kullanım:
 *   {isLoading ? <SkeletonCard count={5} /> : <DataList />}
 *
 * Variant'lar:
 *   - 'card'     (varsayılan): kart şeklinde, başlık + 2 satır + footer
 *   - 'row'      : tablo satırı şeklinde tek satır
 *   - 'stat'     : dashboard stat card iskeleti
 */
export default function SkeletonCard({
  count = 3,
  variant = 'card',
  className,
}) {
  if (variant === 'row') {
    return (
      <div className={cn('space-y-2', className)}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 p-3 border border-slate-100 rounded-lg">
            <Skeleton className="w-10 h-10 rounded-lg flex-shrink-0" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-3 w-1/2" />
            </div>
            <Skeleton className="h-8 w-16 rounded-md flex-shrink-0" />
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'stat') {
    return (
      <div className={cn('grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4', className)}>
        {Array.from({ length: count }).map((_, i) => (
          <Card key={i} className="p-4">
            <div className="flex items-center gap-3">
              <Skeleton className="w-10 h-10 rounded-xl flex-shrink-0" />
              <div className="flex-1 space-y-2 min-w-0">
                <Skeleton className="h-5 w-12" />
                <Skeleton className="h-3 w-20" />
              </div>
            </div>
          </Card>
        ))}
      </div>
    );
  }

  // Varsayılan: card variant
  return (
    <div className={cn('space-y-3', className)}>
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i} className="p-4">
          <div className="flex items-start justify-between gap-3 mb-3">
            <div className="space-y-2 flex-1">
              <Skeleton className="h-5 w-2/3" />
              <Skeleton className="h-3 w-1/2" />
            </div>
            <Skeleton className="h-6 w-16 rounded-full flex-shrink-0" />
          </div>
          <Skeleton className="h-3 w-full mb-2" />
          <Skeleton className="h-3 w-4/5 mb-3" />
          <div className="flex items-center justify-between pt-2 border-t border-slate-100">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-9 w-24 rounded-md" />
          </div>
        </Card>
      ))}
    </div>
  );
}
